import * as Yup from 'yup'

const keysToExclude = ['footerImageOne', 'footerImageTwo', 'footerImageThree', 'cashbackTableHeaderFour',
  'loyaltyTableHeaderFour', 'loyaltyTableHeaderFive', 'loyaltyTableHeaderSix', 'loyaltyTableHeaderSeven']

export const uploadCSVSchema = () => Yup.object().shape({
  languageCsv: Yup.mixed().required('File Required')
    .test('FILE_FORMAT', 'Uploaded file has unsupported format.',
      (value) => !value || (value && ['xls', 'csv'].includes(getExtension(value?.name))))
    .required('File Required')
})

const getExtension = (filename) => {
  return filename.split('.').pop()
}

export const languageWiseSchema = (obj) => Yup.object().shape({
  languageKeys: Yup.object().shape(languageWiseValidate(obj))
})

const languageWiseValidate = (obj) => {
  const validationObject = {}
  for (const file in obj) {
    if (!keysToExclude.includes(file)) {
      validationObject[file] = Yup.string().required('Value Required').nullable()
    }
  }
  return validationObject
}

export const keysWiseSchema = (key, data) => Yup.object().shape({
  [key]: Yup.object().shape(keyWiseValidate(data, key))
})

const keyWiseValidate = (obj, key) => {
  const validationObject = {}
  for (const file in obj) {
    if (!keysToExclude.includes(key)) {
      validationObject[file] = Yup.string().required('Value Required').nullable()
    }
  }
  return validationObject
}
